








































































import {
  computed, defineComponent, PropType, ref,
} from 'vue';

import NetworkCreateForm from '@/components/NetworkCreateForm.vue';
import NetworkUploadForm from '@/components/NetworkUploadForm.vue';
import NetworkMultiCSVUploadForm from '@/components/NetworkMultiCSVUploadForm.vue';
import store from '@/store';

export default defineComponent({
  name: 'NetworkDialog',
  components: {
    NetworkCreateForm,
    NetworkUploadForm,
    NetworkMultiCSVUploadForm,
  },
  props: {
    edgeTables: {
      type: Array as PropType<string[]>,
      required: true,
    },

    workspace: {
      type: String as PropType<string>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const networkDialog = ref(false);
    const CSVNetworkDialog = ref(false);

    const userCanEdit = computed(() => store.getters.userCanEdit);

    function networkDialogSuccess() {
      networkDialog.value = false;
      emit('success');
    }
    function CSVNetworkDialogSuccess() {
      CSVNetworkDialog.value = false;
      emit('success');
    }
    return {
      networkDialog,
      CSVNetworkDialog,
      userCanEdit,
      networkDialogSuccess,
      CSVNetworkDialogSuccess,
    };
  },
});
